<template>
  <div>
    <b-button
      id="notification-centre-bell"
      variant="transparent"
      class="btn btn-link p-0 hitbox-min-width text-right position-relative bell-button"
      data-cy="open-notifications"
      @click="openNotificationCentre"
    >
      <span class="sr-only">{{ $t('notification_centre.show_notification_centre') }}</span>
      <b-badge
        v-if="$store.state.notification.unreadNotifications"
        class="notification-badge position-absolute small px-1 d-flex align-items-center justify-content-center"
        data-cy="nc-bell"
        variant="primary"
      >
        {{ notificationCounter }}
        <span class="sr-only">{{ $t('notification_centre.title') }}</span>
      </b-badge>
      <sdui-icon :class="isNotificationCentrePopOverVisible ? 'icon-bell text-primary' : 'icon-bell-o text-muted'" class="icon-28" />
    </b-button>
    <PopOver
      v-if="!displayAsFullPage"
      id="notification-centre-pop-over"
      v-model:shown="isNotificationCentrePopOverVisible"
      placement="bottom-end"
      :triggers="['click', 'focus']"
      strategy="fixed"
      theme="notification-center"
      :auto-hide="autoHidePopOver"
      :delay="0"
      popper-class="notification-centre-popover"
    >
      <template #popper>
        <h3 class="popover-header">
          <div class="d-flex justify-content-between align-items-center font-weight-normal notification-title">
            <p class="mb-0">{{ $t('notification_centre.title') }}</p>
          </div>
        </h3>
        <div class="popover-body">
          <notification-centre-list @close-pop-over="isNotificationCentrePopOverVisible = false" />
        </div>
      </template>
    </PopOver>
  </div>
</template>

<script>

import NotificationCentreList from 'src/components/notificationCentre/NotificationCentreList.vue'
import isMobileDeviceMixin from 'src/mixins/miscellaneous/isMobileDeviceMixin.js'
import { Dropdown as PopOver } from 'floating-vue'

export default {
  name: 'NotificationCentreBell',
  components: { NotificationCentreList, PopOver },
  mixins: [isMobileDeviceMixin],
  props: {
    popOverNotInViewport: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    chatId: null,
    isNotificationCentrePopOverVisible: false,
    autoHidePopOver: true
  }),

  computed: {
    displayAsFullPage() {
      return this.hasMobileSize || this.isMobile
    },

    notificationCounter() {
      const count = this.$store.state.notification.unreadNotifications
      return count < 100 ? count : '99+' // max 2 digits
    },
  },

  methods: {
    openNotificationCentre() {
      // if the notification centre is displayed as full page (mobile), we don't need to open the popover.
      // Instead, redirect to the notification centre route
      if (this.displayAsFullPage) {
        return this.$router.push({
          name: 'notification-centre',
        })
      }

      // display the popOver
      this.isNotificationCentrePopOverVisible = true
    },
  },

  watch: {
    isNotificationCentrePopOverVisible(newVal) {
      this.$store.commit('SET_HEADER_DISABLED', newVal)

      // set focus to bell icon button when popover is closed
      if (newVal) return
      const btnBellIconEl = document.getElementById('notification-centre-bell')
      if (!btnBellIconEl) return
      btnBellIconEl.focus()
    },
  },

  mounted() {
    this.$root.$on('bv::modal::show', () => {
      this.autoHidePopOver = false
    })
    this.$root.$on('bv::modal::hidden', () => {
      this.autoHidePopOver = true
    })
  },
}
</script>

<style scoped lang="scss">
.notification-badge {
  top: 0 !important;
  left: 30px;
  font-size: pxtorem(11) !important;
  min-width: 16px;
  height: 16px;
  outline: 2px solid $color-white;
}

.bell-button:hover :deep(*::before) {
  color: $color-primary;
}
</style>
